import { createFileRoute, useParams } from "@tanstack/react-router";
import { InvoiceDetailPage } from "@/components/inventory/InvoiceDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/invoices_/$id")({
  component: AdminInvoiceDetail,
});

function AdminInvoiceDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/invoices_/$id" });
  return <InvoiceDetailPage invoiceId={id} />;
}
